// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"340":"6a762862","352":"82a1b350","532":"f6d7f0a7","675":"e55c45a8","805":"78502839"}[chunkId] + ".chunk.js";
};